import { ImageBackground, Platform } from 'react-native';

import { ScrollView } from 'react-native-gesture-handler';
import { RFPercentage, RFValue } from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Ionicons from 'react-native-vector-icons/Ionicons';
import FontAwesome from 'react-native-vector-icons/FontAwesome';

export const Container = styled.View`
  flex: 1;
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
  background-color: ${({ theme }) => theme.colors.background};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  margin-top: -${RFValue(20)}px;
  padding-top: ${RFValue(20)}px;
`;

//@ts-ignore
export const HelpArticleList = styled(ScrollView)`
  margin: 0 -24px;
  margin-top: ${RFValue(12)}px;
`;

export const TutorialsButtonContainer = styled.View`
  padding: 0 24px;
  margin-top: ${RFValue(12)}px;
`;

export const FooterTitle = styled.Text`
  color: ${({ theme }) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  margin-bottom: ${RFValue(10)}px;
`;

export const Footer = styled.View`
  padding: 0 24px;
  border-style: solid;
  border-top-width: 1px;
  border-top-color: ${({ theme }) => theme.colors.border};
  padding-bottom: ${Platform.OS === 'ios' ? RFValue(12) : RFValue(20)}px;
  padding-top: ${Platform.OS === 'ios' ? RFValue(12) : RFValue(15)}px;
`;
export const LinkButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: ${RFValue(12)}px;
`;

export const SupportContactTitle = styled.Text`
  font-family: ${({ theme }) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({ theme }) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(6)}px;
`;

export const LinkButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({ theme }) => theme.colors.blue};
  border-style: solid;
`;

export const LinkButtonText = styled.Text`
  font-family: ${({ theme }) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({ theme }) => theme.colors.blue};
`;

export const HelpVideoContainer = styled.TouchableOpacity`
  width: 100%;

  justify-content: flex-end;
  height: ${RFPercentage(35)}px;
`;

//@ts-ignore
export const HelpVideoThumb = styled(ImageBackground)`
  width: 100%;
  height: 100%;
`;

export const VideoInfos = styled.View`
  position: absolute;
  bottom: ${RFValue(32)}px;
  padding: 0 24px;
`;

export const HelpVideoTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  margin-top: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.shape};
`;

export const HelpVideoSubtitle = styled.Text`
  font-size: ${RFValue(12)}px;

  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.shape};
`;
export const WhatsappContainer = styled.View`
  flex-direction: row;
  justify-content: center;
`;
export const TimeText = styled.Text`
  text-align: center;
  font-size: ${RFValue(12)}px;
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fonts.regular};
`;

export const FooterSupportInfos = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const WhatsappIcon = styled(Ionicons)`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${RFValue(18)}px;

  margin-right: ${RFValue(6)}px;
`;

export const SupportContactList = styled.View`
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(8)}px;
`;
export const SupportContactItem = styled.View`
  flex-direction: row;
  margin-bottom: ${RFValue(4)}px;
  align-items: center;
`;
export const SupportContactIcon = styled(FontAwesome)`
  margin-right: ${RFValue(6)}px;
  font-size: ${RFValue(15)}px;
  color: ${({ theme }) => theme.colors.primary};
`;
export const SupportContactText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fonts.regular};
`;
